import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import GrilleVilles from "./components/GrilleVilles";
import CarteGoogle from "./components/CarteGoogle";
import TexteCommune from "./components/TexteCommune";
import Formulaire from "./components/Formulaire";
import CTAAppel from "./components/CTAAppel";

export default function ZonesDIntervention() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Zones Intervention Volet Roulant Strasbourg | Bas-Rhin"
        description="Dépan'Volets intervient dans tout le Bas-Rhin : Strasbourg, Schiltigheim, Haguenau, Sélestat et plus. Réparation et motorisation de volet roulant. 03 74 47 32 40."
        path="/zones-d-intervention"
        type="website"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Zones d'intervention" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Zones d'intervention" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <GrilleVilles />
        <CarteGoogle />
        <TexteCommune />
        <Formulaire />
        <CTAAppel />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}